const WYSIWYG_MARGIN_TOP = 30;

const expandPlugin = {
    register(globalCK) {
        if (globalCK.plugins.get('ia-expand-tool')) {
            return;
        }

        globalCK.plugins.add('ia-expand-tool', {
            icons: '',
            init: (editorInstance) => { this.init(editorInstance); },
        });
    },

    init(editorInstance) {
        editorInstance.addCommand('toggleExpand', {
            exec: () => { this.toggle(editorInstance); },
        });
        editorInstance.ui.addButton('IA Expand', {
            label: 'Expand',
            command: 'toggleExpand',
            toolbar: 'expand',
        });

        const resize = () => {
            this.resize(editorInstance);
        };

        editorInstance.on('instanceReady', () => {
            window.addEventListener('resize', resize);
        });

        editorInstance.on('destroy', () => {
            removeEventListener('resize', resize);
        });
    },

    toggle(editorInstance) {
        if (this.isExpanded(editorInstance)) {
            this.restore(editorInstance);
        } else {
            this.expand(editorInstance);
        }
    },

    expand(editorInstance) {
        try {
            const outerElement = this.getOuterElement(editorInstance);
            outerElement.style.width = '100%';
            outerElement.style.position = 'fixed';
            outerElement.style.top = `${this.getTopOffset(editorInstance)}px`;
            outerElement.style.left = '0px';
            outerElement.style.zIndex = 200;
            outerElement.className = `${outerElement.className} ckeditor-full-screen`;

            const wysiwygElement = this.getWysiwygElement(editorInstance);

            this.restoreHeight = wysiwygElement.style.height;
            this.restoreMargin = wysiwygElement.style.marginTop;
            wysiwygElement.style.height = `${this.calculateHeight(editorInstance)}px`;
            wysiwygElement.style.marginTop = `${WYSIWYG_MARGIN_TOP}px`;
        } catch (error) {
            window.console.error(error);
        }
    },

    restore(editorInstance) {
        try {
            const outerElement = this.getOuterElement(editorInstance);
            outerElement.style.width = '';
            outerElement.style.position = '';
            outerElement.style.top = '';
            outerElement.style.left = '';
            outerElement.style.zIndex = '';
            outerElement.className = outerElement.className.replace(/ ckeditor-full-screen/g, '');

            const wysiwygElement = this.getWysiwygElement(editorInstance);
            wysiwygElement.style.height = this.restoreHeight;
            wysiwygElement.style.marginTop = this.restoreMargin;
        } catch (error) {
            window.console.error(error);
        }
    },

    resize(editorInstance) {
        try {
            if (this.isExpanded(editorInstance)) {
                const wysiwygElement = this.getWysiwygElement(editorInstance);
                wysiwygElement.style.height = `${this.calculateHeight(editorInstance)}px`;
            }
        } catch (error) {
            window.console.error(error);
        }
    },

    calculateHeight(editorInstance) {
        const winHeight = window.innerHeight;
        const bottomElement = this.getBottomElement(editorInstance);
        const topBarElement = this.getTopBarElement(editorInstance);

        return winHeight
            - this.getTopOffset(editorInstance)
            - bottomElement.offsetHeight
            - topBarElement.offsetHeight
            - WYSIWYG_MARGIN_TOP;
    },

    getOuterElement(editorInstance) {
        return document.querySelector(`.${editorInstance.id}`);
    },

    getTopBarElement(editorInstance) {
        return document.querySelector(`#${editorInstance.id}_top`);
    },

    getWysiwygElement(editorInstance) {
        return document.querySelector(`.${editorInstance.id} div.cke_wysiwyg_div`);
    },

    getBottomElement(editorInstance) {
        return document.querySelector(`#${editorInstance.id}_bottom`);
    },

    getTopOffset() {
        return parseInt(document.getElementById('header').offsetHeight, 10);
    },

    isExpanded(editorInstance) {
        const outerElement = this.getOuterElement(editorInstance);
        return outerElement.className.indexOf('ckeditor-full-screen') !== -1;
    },
};

export default expandPlugin;
